import { render, staticRenderFns } from "./ProjectAddUnit.vue?vue&type=template&id=97b05f6c"
import script from "./ProjectAddUnit.vue?vue&type=script&lang=js"
export * from "./ProjectAddUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports